import {
  Box,
  Grid,
  IconButton,
  styled,
  TableCell,
  Tabs,
  Typography,
} from '@mui/material';

export const MuiTabs = styled(Tabs)(({ theme }) => ({
  '& .Mui-selected': {
    color: theme.palette.brand.black,
  },
}));

export const Divider = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid ${theme.palette.divider}
  `,
);

export const TableDivider = styled(Box)(
  () => `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  `,
);
export const IconWrapper = styled(IconButton)`
  height: 24px;
  width: 24px;
  margin: 0 3px;
`;
export const StyledTableCell = styled(TableCell)`
  border-bottom: none;
`;
export const Container = styled(Grid)`
  width: 77vw;
`;

export const StyledBox = styled(Box)<{ width?: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: ${({ width }: { width?: string }) => width || '65.3%'};
`;
export const StyledStack = styled(Grid)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const optionsStyle = {
  hint: 'Upload sticker',
  hintStyle: { fontSize: '12px' },
  iconStyle: {
    width: '20px',
    height: '20px',
  },
  imageStyle: {
    width: '76px',
    height: '76px',
  },
  fileTypes: 'image/png, image/jpeg, image/gif, image/jpg',
};

export const StyledTypography = styled(Typography)({
  overflow: 'hidden',
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
  whiteSpace: 'pre-wrap',
  textOverflow: 'ellipsis',
  fontWeight: 400,
  width: 'auto',
  wordBreak: 'break-word',
});

export const VariationAssetsContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  backgroundColor: theme.palette.background.paper,
  overflow: 'hidden',
}));

export const VariationAssetsItemWrapper = styled(Box)(({ theme }) => ({
  paddingLeft: `20px`,
  paddingRight: `20px`,
  paddingTop: 1.5,
  paddingBottom: 1.5,
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const DyHeaderContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
});

export const VariationAssetsHeader = styled(Grid)(({ theme }) => ({
  marginBottom: 0,
  backgroundColor: '#f6f6f6',
  borderRadius: 0,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingRight: '16px',
  paddingLeft: '16px',
  paddingTop: '12px',
  paddingBottom: '12px',
  transition: 'none',
  justifyContent: 'space-between',
  '&:hover': {
    boxShadow: 'none',
  },
}));
